export default {
    mounted(el) {
      const input = el.querySelector('.p-inputnumber-input');
      if (input) {
        input.setAttribute('inputmode', 'decimal');
        input.setAttribute('pattern', '\\d*\\.?\\d*');
      }
    },
    updated(el) {
      const input = el.querySelector('.p-inputnumber-input');
      if (input) {
        input.setAttribute('inputmode', 'decimal');
        input.setAttribute('pattern', '\\d*\\.?\\d*');
      }
    }
  };
  